import React from "react";
import Markdown from "react-markdown";

const TrainingCourseViewer = ({ course }) => {
  
  return (
    <div className="training-course-viewer">
      <div className="viewer-header">
        <span>{course?.title}</span>
      </div>
      <div className="viewer">
        <Markdown>{course?.content}</Markdown>
      </div>
    </div>
  );
}

export default TrainingCourseViewer;
